document.addEventListener('DOMContentLoaded', function() {
  const MAX_QUANTITY = 10;
  
  // Function to show notification
  function showNotification(message) {
    // Only create notification if it doesn't exist
    if (!document.getElementById('quantity-limit-notification')) {
      const notification = document.createElement('div');
      notification.id = 'quantity-limit-notification';
      notification.style.cssText = 'position:fixed; bottom:20px; left:50%; transform:translateX(-50%); background:#096cb9; color:white; padding:10px 20px; border-radius:4px; z-index:9999; opacity:0; transition:opacity 0.3s ease;';
      notification.textContent = message;
      document.body.appendChild(notification);
      
      // Show notification
      setTimeout(() => notification.style.opacity = '1', 10);
      
      // Hide notification after 3 seconds
      setTimeout(() => {
        notification.style.opacity = '0';
        setTimeout(() => notification.remove(), 300);
      }, 3000);
    }
  }
  
  // Handle quantity input changes and enforce max quantity
  document.addEventListener('change', function(event) {
    if (event.target.matches('input[name="updates[]"], input[name="quantity"]')) {
      const input = event.target;
      const maxValue = parseInt(input.getAttribute('max'), 10) || MAX_QUANTITY;
      const currentValue = parseInt(input.value, 10);
      
      if (currentValue > maxValue) {
        input.value = maxValue;
        showNotification('Maximum quantity is ' + maxValue + ' per item');
        
        // If in cart page, manually trigger cart update
        if (window.location.href.includes('/cart')) {
          const form = input.closest('form');
          if (form) {
            const updateButton = form.querySelector('button[name="update"]');
            if (updateButton) {
              setTimeout(() => updateButton.click(), 10);
            }
          }
        }
      }
    }
  });
  
  // Watch for cart updates to preserve sections
  document.addEventListener('line-item:change:start', function() {
    // Save references to shipping estimator and product recommendations
    window.savedShippingEstimator = document.querySelector('.shipping-estimator')?.outerHTML;
    window.savedProductRecommendations = document.querySelector('.product-recommendations')?.outerHTML;
  });
  
  document.addEventListener('line-item:change:end', function() {
    // After cart update, restore sections if they disappeared
    setTimeout(() => {
      const shippingEstimator = document.querySelector('.shipping-estimator');
      const productRecommendations = document.querySelector('.product-recommendations');
      
      // Restore shipping estimator if it disappeared
      if (!shippingEstimator && window.savedShippingEstimator) {
        const cartForm = document.querySelector('.thb-cart-form');
        if (cartForm) {
          const container = document.createElement('div');
          container.innerHTML = window.savedShippingEstimator;
          cartForm.appendChild(container);
        }
      }
      
      // Restore product recommendations if they disappeared
      if (!productRecommendations && window.savedProductRecommendations) {
        const cartForm = document.querySelector('.thb-cart-form');
        if (cartForm) {
          const container = document.createElement('div');
          container.innerHTML = window.savedProductRecommendations;
          cartForm.appendChild(container);
        }
      }
      
      // Reinitialize any scripts that may need it
      if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
        const countrySelector = document.querySelector('#AddressCountry');
        const provinceSelector = document.querySelector('#AddressProvince');
        if (countrySelector && provinceSelector) {
          new Shopify.CountryProvinceSelector('AddressCountry', 'AddressProvince', {
            hideElement: 'AddressProvinceContainer'
          });
        }
      }
    }, 300);
  });
  
  // Fix for ThemeCart to include all sections in updates
  if (typeof ThemeCart !== 'undefined' && ThemeCart.prototype.getSectionsToRender) {
    const originalGetSectionsToRender = ThemeCart.prototype.getSectionsToRender;
    
    ThemeCart.prototype.getSectionsToRender = function() {
      // Get original sections
      const sections = originalGetSectionsToRender.call(this);
      
      // Add shipping estimator and recommendations sections if they exist
      if (document.querySelector('.shipping-estimator')) {
        sections.push({
          id: 'shipping-estimator',
          section: 'cart',
          selector: '.shipping-estimator'
        });
      }
      
      if (document.querySelector('.product-recommendations')) {
        sections.push({
          id: 'product-recommendations',
          section: 'cart',
          selector: '.product-recommendations'
        });
      }
      
      return sections;
    };
  }
});